// Candidate for use elsewhere.
/**
 * Takes a given string and places an ellipsis as needed.
 * @param text The string to inspect.
 * @param maxLength The maximum allowed length of the string.
 */
function ellipsify(text: string, maxLength = 20): string {
  let outputText = text;
  let suffix = "";
  if (text && text.length > maxLength) {
    outputText = text.substring(0, maxLength);
    suffix = "...";
  }

  return `${outputText}${suffix}`;
}

interface NamespaceParts {
  beginning: string;
  end: string;
  root: string;
}

/**
 * Extracts the constiuent parts of a namespace path.
 * @param namespacePath The path to parse and extract from.
 */
function extractParts(namespacePath: string): NamespaceParts {
  if (!namespacePath) {
    return null;
  }

  try {
    const rootEnd = namespacePath.indexOf("\u00A7", 1); // §
    const root = namespacePath.substring(1, rootEnd);
    const beginningEnd = namespacePath.lastIndexOf("\u00A7"); // §
    const beginning = namespacePath.substring(rootEnd + 1, beginningEnd);
    const end = namespacePath.substring(beginningEnd + 1);

    return {
      beginning,
      end,
      root,
    };
  } catch {
    throw new Error("Cannot extract parts of a malformed namespace path.");
  }
}

export { ellipsify, extractParts };
